import { VFC } from 'react';
import { useStore } from 'routes/installation/useStore';
import { Tooltip } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useInstallMeterStepsStore } from '../../components/store';
import { Button } from '../../../../components/Button/Button';
import { selectIsHardwaresStepOK } from './selectors';
import { HardwaresStepFooter as messages } from './messages';

export const HardwaresStepFooter: VFC = () => {
  const { setPreviousStep, setNextStep } = useInstallMeterStepsStore();
  const { hardwares } = useStore();
  const isStepOK = useStore(selectIsHardwaresStepOK);
  const intl = useIntl();

  const buttonConfig =
    hardwares.length > 0
      ? { key: 'submit', form: 'installMeterHardwaresForm', htmlType: 'submit' as const }
      : { onClick: () => setNextStep() };

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Tooltip placement="top" title={isStepOK ? null : intl.formatMessage(messages.tooltip)}>
        <Button block disabled={!isStepOK} type="primary" {...buttonConfig}>
          <FormattedMessage {...messages.next} />
        </Button>
      </Tooltip>
    </>
  );
};
